import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//api
import { getProducts } from 'api/products';
//components
import AutoCompleteInput from './autoCompleteInput';
import Input from './index';

const SearchProduct = ({
  filterBy,
  onSelected,
  placeholder,
  defaultArticle = null,
  showLabel = '',
  fields = 'id,title,image,ean,publicada',
  includeInactive = false,
}) => {
  const [articleSelected, setArticleSelected] = useState(null);
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (defaultArticle) {
      const displayValue = filterBy === 'ean' ? defaultArticle.ean : defaultArticle.title;
      setArticleSelected({
        label: displayValue,
        value: defaultArticle.id,
      });
      setInputValue(displayValue || '');
      if (filterBy === 'ean' && displayValue) {
        setShowInput(true);
      } else {
        setShowInput(false);
      }
    } else {
      setArticleSelected(null);
      setInputValue('');
      setShowInput(false);
    }
  }, [defaultArticle, filterBy]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      let queryField = filterBy;
      if (filterBy.includes(',')) {
        const [fieldByTitle, fieldByEan] = filterBy.split(',').map((f) => f.trim());
        const isEan = /^[0-9]+$/.test(value);
        queryField = isEan ? fieldByEan : fieldByTitle;
      }
      const payload = {
        [queryField]: value,
        page: 1,
        page_size: 10,
        fields: fields,
      };
      if (includeInactive) {
        payload.include_inactive = true;
      }
      const { status, data } = await getProducts(payload);
      if (status === 200) {
        return data?.results?.map((item) => {
          return {
            ...item,
            label: `${item.title} (${item.ean})`,
            value: item.id,
          };
        });
      }
    }
    return [];
  };

  const handleInputChange = (value) => {
    const originalValue = defaultArticle?.ean || '';
    if (value === '') {
      setShowInput(false);
      setArticleSelected(null);
      setInputValue('');
      onSelected(null);
      return;
    }
    if (value !== originalValue) {
      setShowInput(false);
      setArticleSelected(null);
      setInputValue('');
      onSelected(null);
      return;
    }
    setInputValue(value);
  };

  const handleInputBlur = () => {
    const originalValue = defaultArticle?.ean || '';
    if (inputValue === '' || inputValue !== originalValue) {
      setShowInput(false);
      setArticleSelected(null);
      onSelected(null);
    }
  };

  if (filterBy === 'ean' && showInput && articleSelected && inputValue) {
    return (
      <Input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        placeholder={placeholder}
        dataTestId={`input_${filterBy}`}
      />
    );
  }

  return (
    <AutoCompleteInput
      label={showLabel}
      defaultOptions={articleSelected ? [articleSelected] : []}
      defaultValue={articleSelected}
      onSelect={(item) => {
        if (filterBy === 'ean' && item && item.ean) {
          setShowInput(true);
          setInputValue(item.ean);
        } else {
          setShowInput(false);
        }
        onSelected(item);
      }}
      onSearch={onSearch}
      placeholder={placeholder}
    />
  );
};

SearchProduct.propTypes = {
  filterBy: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultArticle: PropTypes.object,
  showLabel: PropTypes.string,
  fields: PropTypes.string,
  includeInactive: PropTypes.bool,
};

export default SearchProduct;
